/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDevice200Response
 */
export interface CreateDevice200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    platform: CreateDevice200ResponsePlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    osVersion: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    appVersion: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    webviewVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    nativeVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    mode: CreateDevice200ResponseModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDevice200Response
     */
    isDataphone: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    preferredCashMachine: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    preferredDataphone: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    preferredTill: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDevice200Response
     */
    useSelfPrinter: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDevice200Response
     */
    accessToken: string;
}


/**
 * @export
 */
export const CreateDevice200ResponsePlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    Electron: 'electron',
    Web: 'web'
} as const;
export type CreateDevice200ResponsePlatformEnum = typeof CreateDevice200ResponsePlatformEnum[keyof typeof CreateDevice200ResponsePlatformEnum];

/**
 * @export
 */
export const CreateDevice200ResponseModeEnum = {
    Master: 'master',
    Slave: 'slave'
} as const;
export type CreateDevice200ResponseModeEnum = typeof CreateDevice200ResponseModeEnum[keyof typeof CreateDevice200ResponseModeEnum];


/**
 * Check if a given object implements the CreateDevice200Response interface.
 */
export function instanceOfCreateDevice200Response(value: object): value is CreateDevice200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('osVersion' in value) || value['osVersion'] === undefined) return false;
    if (!('appVersion' in value) || value['appVersion'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('isDataphone' in value) || value['isDataphone'] === undefined) return false;
    if (!('preferredCashMachine' in value) || value['preferredCashMachine'] === undefined) return false;
    if (!('preferredDataphone' in value) || value['preferredDataphone'] === undefined) return false;
    if (!('preferredTill' in value) || value['preferredTill'] === undefined) return false;
    if (!('useSelfPrinter' in value) || value['useSelfPrinter'] === undefined) return false;
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    return true;
}

export function CreateDevice200ResponseFromJSON(json: any): CreateDevice200Response {
    return CreateDevice200ResponseFromJSONTyped(json, false);
}

export function CreateDevice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDevice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'platform': json['platform'],
        'model': json['model'],
        'osVersion': json['osVersion'],
        'appVersion': json['appVersion'],
        'webviewVersion': json['webviewVersion'] == null ? undefined : json['webviewVersion'],
        'nativeVersion': json['nativeVersion'] == null ? undefined : json['nativeVersion'],
        'mode': json['mode'],
        'isDataphone': json['isDataphone'],
        'preferredCashMachine': json['preferredCashMachine'],
        'preferredDataphone': json['preferredDataphone'],
        'preferredTill': json['preferredTill'],
        'useSelfPrinter': json['useSelfPrinter'],
        'accessToken': json['accessToken'],
    };
}

export function CreateDevice200ResponseToJSON(json: any): CreateDevice200Response {
    return CreateDevice200ResponseToJSONTyped(json, false);
}

export function CreateDevice200ResponseToJSONTyped(value?: CreateDevice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'platform': value['platform'],
        'model': value['model'],
        'osVersion': value['osVersion'],
        'appVersion': value['appVersion'],
        'webviewVersion': value['webviewVersion'],
        'nativeVersion': value['nativeVersion'],
        'mode': value['mode'],
        'isDataphone': value['isDataphone'],
        'preferredCashMachine': value['preferredCashMachine'],
        'preferredDataphone': value['preferredDataphone'],
        'preferredTill': value['preferredTill'],
        'useSelfPrinter': value['useSelfPrinter'],
        'accessToken': value['accessToken'],
    };
}

